/*globals STATIC_URL*/
import React from 'react';
import { connect } from 'react-redux';
import InitializePurchase from './InitializePurchase';
import RefinePurchase from './RefinePurchase';
import FinalizePurchase from './FinalizePurchase';
import FinalizeSocialPay from './FinalizeSocialPay';
import { BreadcrumbNav, BreadcrumbItem } from 'views/Breadcrumb';
import Icon from 'views/Icon';
import Rupee from 'views/Rupee';
import formFieldsHandler from 'decorators/FormFieldsHandler';
import {
  handleToggleOpenState,
  handleTogglePaymentPopup,
  setOfferPagePaymentButtonClickListener,
  showDeferredMerchantHeader,
} from '../actions/SettingsActions';
import { TABS } from '../constants/SettingsConstants';
import { Row, Columns } from 'views/Grid';
import classNames from 'classnames';
import ProductsMerchantHeader from './products/ProductsMerchantHeader';
import LinksMerchantHeader from './links/LinksMerchantHeader';
import InstapayMerchantHeader from './instapay/InstapayMerchantHeader';
import InstapayForm from './instapay/InstapayForm';
import CartConvenienceFee from 'views/full/CartConvenienceFee';
import ConvenienceFeesAccordion from './convenience-fee/ConvenienceFeesAccordion';
import PostPurchase from './PostPurchase';
import track from 'analytics/track';
import BreadcrumbAnimation from 'views/BreadcrumbAnimation';
import { LayoutStyles } from 'cart/config';
import { Modes } from 'cart/config';
import CartHeader from 'cart/views/CartHeader';
import PaymentCompletionLoader from './finalize/PaymentCompletionLoader';
import { getCartTotalItems } from '../utils/GlobalUtils';
import root from 'window-or-global';

import {
  isRunningInIframe,
  isSmallDevice,
} from 'config/utils';

import {
  getPaymentsState,
} from '../reducers';

import Modal, {
  ModalContent, ModalClose, contentWrapperStyles,
} from 'views/Modal';

class Payments extends React.Component {
  componentDidMount () {
    // the app is ready - broadcast to anyone listening.
    root.parent.postMessage('onRequestShow', '*');

    if (!this.props.settings.isPaymentResponse) {
      this.props.setOfferPagePaymentButtonClickListener();
      this.props.showDeferredMerchantHeader();
      track();
    }
  }

  handleRequestCloseParentWindow () {
    parent.postMessage('onRequestClose', '*');
  }

  handleKeyDown (event) {
    if (event.keyCode === 27 /*esc*/) {
      event.preventDefault();
      this.handleRequestCloseParentWindow();
    }
  }

  onRequestClose () {
    this.props.handleTogglePaymentPopup();
    this.props.setOfferPagePaymentButtonClickListener();
  }

  _getFrameBackground(responseType) {
    const {
      isRetrying,
    } = this.props.settings;

    if (isRetrying) {
      return 'none';
    }

    return responseType === 'product' || responseType === 'cart' ? '#F1F4F6' : 'none';
  }

  _renderPaymentForm () {
    const {
      isShowRefinePurchaseBox,
      isShowFinalizePurchaseBox,
      isInitializeFormOpen,
      isInitializeFormOpenable,
      initializeHeading,
      isRefineFormOpen,
      isRefineFormOpenable,
      refineHeading,
      isFinalizeFormOpen,
      isFinalizeFormOpenable,
      finalizeHeading,
      isShowInitializePurchaseBox,
      isShowFinalizeSocialPayBox,
      isFinalizeSocialPayFormOpen,
      isFinalizeSocialPayFormOpenable,
      socialPayHeading,
      isOfferAvailable,
      isLinkPayment,
      isInstapayPayment,
      isRetrying,
      showConvenienceFee,
      isAwaitingPaymentCompletion,
    } = this.props.settings;

    const {
      selectedPaymentMode,
      totalAmountFormatted,
    } = this.props;

    const showBreadcrumbNavTopBorder = isLinkPayment || isInstapayPayment || (showConvenienceFee && selectedPaymentMode);

    if (!isOfferAvailable) {
      return (
        <div className="payments-form">
          <div className="soft center">
            <Icon className="ui-2_alert-circle-" style={{ fontSize: 48, margin: '10px 0 20px', color: '#E83C58' }} />
            <p>Payments are unavailable.</p>
          </div>
        </div>
      );
    }

    const {
      isBackwardMotion,
      isDirectToPayments,
      isCartOrder,
      isEmbed,
      isIFrame,
    } = this.props.settings;

    const isRetryingCartPayment = isRetrying && isCartOrder;

    return (
      <div ref={(ref) => { this.props.handleAsyncFormState(ref); }}>
        { isAwaitingPaymentCompletion ?
          <PaymentCompletionLoader /> :
          null
        }
        <div className="payments-form" style={isAwaitingPaymentCompletion ? { display: 'none' } : {}}>
          <Row>
            <Columns
              className={classNames('small-12 hard--sides', {
                'medium-8 large-6 medium-centered': isRetryingCartPayment,
              })}>
              { !isDirectToPayments ?
                <div className="soft--sides">
                  { isRetryingCartPayment ?
                    <CartConvenienceFee /> :
                    null
                  }
                  <BreadcrumbNav style={showBreadcrumbNavTopBorder ? {
                      borderTop: '1px solid  rgba(227, 236, 242, 0.5)',
                    } : null}>
                    { isShowInitializePurchaseBox ?
                      <BreadcrumbItem
                        heading={initializeHeading}
                        isActive={isInitializeFormOpen}
                        isActivable={isInitializeFormOpenable}
                        isCompleted={!isInitializeFormOpen}
                        onToggleActiveState={(isOpen) => this.props.handleToggleOpenState(TABS.INITIALIZE, isOpen)}
                        /> : null }

                    { isShowRefinePurchaseBox ?
                      <BreadcrumbItem
                        heading={refineHeading}
                        isActive={isRefineFormOpen}
                        isActivable={isRefineFormOpenable}
                        isCompleted={!isInitializeFormOpen && !isRefineFormOpen}
                        onToggleActiveState={(isOpen) => this.props.handleToggleOpenState(TABS.REFINE, isOpen)}
                        /> : null }

                    { isShowFinalizePurchaseBox ?
                      <BreadcrumbItem
                        heading={finalizeHeading}
                        isActive={isFinalizeFormOpen}
                        isActivable={isFinalizeFormOpenable}
                        onToggleActiveState={(isOpen) => this.props.handleToggleOpenState(TABS.FINALIZE, isOpen)}
                        /> : null }

                    { isShowFinalizeSocialPayBox ?
                      <BreadcrumbItem
                        heading={socialPayHeading}
                        isActive={isFinalizeSocialPayFormOpen}
                        isActivable={isFinalizeSocialPayFormOpenable}
                        onToggleActiveState={(isOpen) => this.props.handleToggleOpenState(TABS.FINALIZE_SP, isOpen)}
                        /> : null }
                  </BreadcrumbNav>
                </div> :
                null
              }

              { isEmbed && !isIFrame && selectedPaymentMode ?
                <div className="push--sides soft-quarter--bottom push--bottom" style={{ borderBottom: '1px solid rgba(227, 236, 242, 0.498039)' }}>
                  <span>Amount</span>
                  <span className="right"><Rupee value={totalAmountFormatted} /></span>
                  <ConvenienceFeesAccordion />
                </div> :
                null
              }

              <Row className="flush--sides">
                <Columns className="small-12">
                  { isInitializeFormOpen ?
                    <BreadcrumbAnimation isBackwardMotion={isBackwardMotion}>
                      <InitializePurchase />
                    </BreadcrumbAnimation>
                  : null }

                  { isShowRefinePurchaseBox && isRefineFormOpen ?
                    <BreadcrumbAnimation isBackwardMotion={isBackwardMotion}>
                      <RefinePurchase />
                    </BreadcrumbAnimation>
                  : null }

                  { isShowFinalizePurchaseBox && isFinalizeFormOpen ?
                    <BreadcrumbAnimation isBackwardMotion={isBackwardMotion}>
                      <FinalizePurchase />
                    </BreadcrumbAnimation>
                  : null }

                  { isShowFinalizeSocialPayBox && isFinalizeSocialPayFormOpen ?
                    <BreadcrumbAnimation isBackwardMotion={isBackwardMotion}>
                      <FinalizeSocialPay />
                    </BreadcrumbAnimation>
                  : null }
                </Columns>
              </Row>
            </Columns>
          </Row>
        </div>
      </div>
    );
  }

  _renderBrandFooter (type) {
    const { imBranding } = this.props.settings;
    const { is_anchor_text } = root.INITIAL_STATE || {};
    if (!imBranding) {
      return <span></span>;
    }

    const footerText = is_anchor_text ? 'Payments powered by' : 'Powered by';
    return (
      <div
        className={classNames('text-center soft-one-half--ends', {
          'text-white': type === 'light',
        })}
        style={{ opacity: 0.5 }}
        >
        { footerText }
        &nbsp;
        <a href={`https://www.instamojo.com/?utm_source=${root.location.hostname}&utm_campaign=powered_by_instamojo&utm_medium=payment_form`} target="_blank">
          <div
            style={{ height: 21, width: 100, display: 'inline-block', verticalAlign: 'middle' }}
            className={type === 'light' ? 'instamojo-logo-light' : 'instamojo-logo-colored'}
            title="Payment Gateway provided by Instamojo" />
        </a>
      </div>
    );
  }

  _renderCloseButton () {
    const {
      isLinkPayment,
      isInstapayPayment,
    } = this.props.settings;
    return (
      <div
        className="payments--close"
        style={{
          position: 'absolute',
          right: '50%',
          color: isSmallDevice() && (isLinkPayment || isInstapayPayment) ? '#2C475D' : '#fff',
          cursor: 'pointer',
        }}
        onClick={() => this.handleRequestCloseParentWindow()}
        >
        <Icon className="ui-1_circle-remove_modal medium"/>
      </div>
    );
  }

  _formErrors (obj) {
    return obj && Object.keys(obj).length && Object.keys(obj).filter(key => obj[key].length).length;
  }

  _wrap (Component, classes, styles) {
    const { initializePurchaseFormErrors, refinePurchaseFormErrors,
      finalizePurchaseFormErrors, settings: { isInitializeFormOpen, isRefineFormOpen,
      isFinalizeFormOpen } } = this.props;

    const hasFormErrors =
      (isInitializeFormOpen && this._formErrors(initializePurchaseFormErrors)) ||
      (isRefineFormOpen && this._formErrors(refinePurchaseFormErrors)) ||
      (isFinalizeFormOpen && this._formErrors(finalizePurchaseFormErrors));

    return (
      <div
        className={classNames('payments-container', hasFormErrors ? 'shake' : null, classes)}
        style={{ ...styles }}
        >
        {Component}
      </div>
    );
  }

  render () {
    const {
      isEmbed, isIFrame, isPaymentPopupOpen, sellerAvatar, seller, showDeferred,
      isLinkPayment, isMerchantViewingOwnLink, isPaymentResponse, responseType,
      isInstapayPayment, isRAP, isInstapayInitiated, isCartOrder, isRetrying,
      shouldShowPaymentOptionsDirectlyOnRetry,
    } = this.props.settings;
    const embedPaymentFormStyles = { width: 'auto', minWidth: 320, maxWidth: 440 };
    const { title, totalAmountFormatted, preview } = this.props;
    const merchantHeaderProps = {
      showDeferred,
      preview,
      sellerAvatar,
      seller,
      title,
      totalAmountFormatted,
    };

    if (isEmbed && isIFrame) {
      //Use transparent background For embed and iframe mode
      document.body.style.background = 'none';
      // remote checkout
      return (
        <div>
          {this._wrap(
            <div onKeyDown={this.handleKeyDown.bind(this)}>
              { isLinkPayment ?
                <LinksMerchantHeader {...merchantHeaderProps} /> :
                isInstapayPayment ?
                  <InstapayMerchantHeader {...merchantHeaderProps} isEditing={!isRAP} /> :
                  <ProductsMerchantHeader {...merchantHeaderProps} />
              }
              { isInstapayPayment && !isRAP && !isInstapayInitiated ?
                <InstapayForm /> :
                this._renderPaymentForm()
              }
            </div>, 'is--embed-iframe'
          )}
          {this._renderBrandFooter('light')}
          {this._renderCloseButton()}
        </div>
      );
    }

    if (isEmbed) {
      // standalone form embedded page
      document.body.style.background = '#F1F4F6';
      return this._wrap(
        <div>
          { isInstapayPayment && !isRAP && !isInstapayInitiated ?
            <InstapayForm /> :
            this._renderPaymentForm()
          }
          {this._renderBrandFooter('dark')}
        </div>, null, embedPaymentFormStyles
      );
    }

    const isRetryingCartPayment = isRetrying && isCartOrder;

    const isMandatoryPayment = isRetrying ? (isRetrying && !isRunningInIframe()) : (isLinkPayment || isInstapayPayment);

    const backdropStyle = {
      background: isRunningInIframe() ? 'none' :
        (isLinkPayment || responseType == 'link') || (isInstapayPayment || responseType == 'instapay') ? '#434A54' :
        isCartOrder ? 'rgba(241, 244, 242, 0.95)' :
        'rgba(0, 0, 0, 0.95)',
    };

    let modalContentContainerStyle = {
      marginTop: isMerchantViewingOwnLink ? '60px' : '48px',
      marginBottom: !this.props.settings.imBranding ? '42px' : '',
    };

    if ((isPaymentResponse || isRetryingCartPayment) && isCartOrder) {
      modalContentContainerStyle = {
        ...modalContentContainerStyle,
        ...LayoutStyles,
      };
    }

    if (isPaymentResponse) {
      return (
        <PostPurchase
          backdropStyle={backdropStyle}
          responseType={responseType}
          isCartOrder={isCartOrder}
          isPaymentPopupOpen={isPaymentPopupOpen}
          modalContentContainerStyle={modalContentContainerStyle}
          shouldShowPaymentOptionsDirectlyOnRetry={shouldShowPaymentOptionsDirectlyOnRetry}
          postPurchase={this.props.postPurchase}
          _wrap={(component, className, style) => this._wrap(component, className, style)}
          _renderBrandFooter={(type) => this._renderBrandFooter(type)}
          onRequestClose={() => {
            this.onRequestClose();
            this.handleRequestCloseParentWindow();
          }}
        />
      );
    }

    // offer page
    return (
      <Modal
        aria-labelledby='payments-modal'
        backdropStyle={backdropStyle}
        show={isPaymentPopupOpen}
        >
        { this._wrap(
          <ModalContent
            isClosable={false}
            handleFullScreenScroll={false}
            style={{ ...modalContentContainerStyle }}>
            {/* Merchant Header */}
            { isLinkPayment ?
              <LinksMerchantHeader {...merchantHeaderProps} /> :
              isInstapayPayment ?
              <InstapayMerchantHeader {...merchantHeaderProps} isEditing={!isRAP} /> :
              isRetryingCartPayment ?
              <div style={{ background: '#fff', borderRadius: '4px 4px 0 0' }}>
                <CartHeader
                  purchased={false}
                  mode={Modes.FULL}
                  totalItems={getCartTotalItems()}
                />
              </div> :
              <ProductsMerchantHeader {...merchantHeaderProps} />
            }

            {/* Core Content */}
            { isInstapayPayment && !isRAP && !isInstapayInitiated ?
              <InstapayForm /> :
              this._renderPaymentForm()
            }

            {/* Footer */}
            { this._renderBrandFooter('light') }

            {/* Enable closing the modal for non link payments */}
            { !isMandatoryPayment ?
              <ModalClose
                className="payments--close"
                onRequestClose={() => {
                  this.onRequestClose();

                  if (isRunningInIframe()) {
                    this.handleRequestCloseParentWindow();
                  }
                }}
                /> :
              null
            }
          </ModalContent>, 'is--embed-iframe', {
            ...contentWrapperStyles,
            background: this._getFrameBackground(responseType),
          }
        )}
      </Modal>
    );
  }
}

export default connect(getPaymentsState, {
  handleToggleOpenState,
  handleTogglePaymentPopup,
  setOfferPagePaymentButtonClickListener,
  showDeferredMerchantHeader,
})(formFieldsHandler(Payments));



// WEBPACK FOOTER //
// ./src/payments/views/Payments.js